import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-reports-columns',
  standalone: false,
  templateUrl: './reports-columns.component.html',
  styleUrl: './reports-columns.component.scss'
})
export class ReportsColumnsComponent implements OnInit {
  ColumnForm = this.formBuilder.group({
    //location
    region: [false],//assessment
    forest_name: [false],//assessment
    forest_org_code: [false],//assessment
    IRWIN_POO_state: [false],//assessment
    ranger_district: [false], //report/forest/ranger_district
    IRWIN_POO_county: [false],//assessment
    //date
    calendar_year: [false],//assessment/fire_discovery_date
    fiscal_year: [false],//report/authorized_on
    //fire details
    baer_name: [false],//assessment
    fire_start_date: [false],//assessment/tentative_start_week
    IRWIN_unique_fire_identifier: [false],//assessment
    job_code: [false],//assessment
    total_fire_acres: [false],//assessment
    source: [false],//assessment
    acres_fsonly: [false],//assessment/est_fire_acres
    fire_complexity: [false],//assessment/fire_complexity_id
    containment_date_est: [false],//assessment
    containment_date: [false],//assessment
    //assessment
    assessment_status: [false],//assessment/assessment_status_id
    team_lead: [false],//assessment/team_lead_id or reports team lead logic
    team_needs: [false],//assessment/team_needs_id
    trainees_needed: [false],//assessment
    tentative_start_week: [false],//assessment
    close_out_date: [false],//assessment
    //report
    report_baer_name: [false],//report
    report_status: [false],//report/report_status_id
    report_id: [false],//report
    report_type: [false],//report
    action_type: [false],//report/report_num calc
    authorization_status: [false],//report/authorization_status_id
    submission_date: [false],//report
    team_members: [false],//report_member/user
    total_funding_req: [false],//treatments calc
    ro_auth: [false],//treatments calc
    wo_auth: [false],//treatments calc
    total_auth: [false],//treatments calc
    //treatment totals
    treatment_all: [false],//treatments calc
    treatment_unit: [false],//treatments calc
    treatment_plants: [false],//treatments calc
    treatment_ground_cover: [false],//treatments calc
    treatment_channel: [false],//treatments calc
    treatment_heritage: [false],//treatments calc
    treatment_roads: [false],//treatments calc
    treatment_safety: [false],//treatments calc
    treatment_monitoring: [false],//treatments calc
    //soil burn severity acres
    soil_burn_sev_developed: [false],//soil_burn_severity calc
    soil_burn_sev_unburned: [false],//soil_burn_severity calc
    soil_burn_sev_low: [false],//soil_burn_severity calc
    soil_burn_sev_moderate: [false],//soil_burn_severity calc
    soil_burn_sev_high: [false],//soil_burn_severity calc
    //user
    name: [false],//user/first and last name
    agency: [false],//user/location_id
    skills_list: [false],//user
    skills_list_read: [false],//user skills list calc
    skill_level: [false],//user skills_list
    fire_assignment: [false],//user calc on report_member
    bear_role: [false],//user/baer_role
  });

  columnList = [
    //location
    { column: 'region', name: 'Region', table: 'assessment' },
    { column: 'forest_name', name: 'Forest', table: 'assessment' },
    { column: 'forest_org_code', name: 'ForestOrgCode', table: 'assessment' },
    { column: 'IRWIN_POO_state', name: 'State of Fire Origin', table: 'assessment' },
    { column: 'ranger_district', name: 'Ranger District', table: 'report/forest/ranger_district' },
    { column: 'IRWIN_POO_county', name: 'Counties', table: 'assessment' },
    //date
    { column: 'calendar_year', name: 'Calendar Year', table: 'assessment' },
    { column: 'fiscal_year', name: 'Fiscal Year', table: 'report' },
    //fire details
    { column: 'baer_name', name: 'Fire/Complex Name', table: 'assessment' },
    { column: 'fire_start_date', name: 'Fire Start Date', table: 'assessment' },
    { column: 'IRWIN_unique_fire_identifier', name: 'Fire Number', table: 'assessment' },
    { column: 'job_code', name: 'Fire Incident Job Code', table: 'assessment' },
    { column: 'total_fire_acres', name: 'Total Fire Acres', table: 'assessment' },
    { column: 'source', name: 'Source', table: 'assessment' },
    { column: 'acres_fsonly', name: 'Est. NFS Acres', table: 'assessment' },
    { column: 'fire_complexity', name: 'Complexity', table: 'assessment' },
    { column: 'containment_date_est', name: 'Est. Containment Date', table: 'assessment' },
    { column: 'containment_date', name: 'Containment Date (GIS)', table: 'assessment' },
    //assessment
    { column: 'assessment_status', name: 'Assessment Status', table: 'assessment' },
    { column: 'team_lead', name: 'Team Lead', table: 'assessment,report,report_member' },
    { column: 'team_needs', name: 'Team Needs', table: 'assessment,team_needs' },
    { column: 'trainees_needed', name: 'Trainees', table: 'assessment' },
    { column: 'tentative_start_week', name: 'Tentative Start Date', table: 'assessment' },
    { column: 'close_out_date', name: 'Close-Out Date', table: 'assessment' },
    //report
    { column: 'report_baer_name', name: 'Report Name', table: 'report' },
    { column: 'report_status', name: 'Report Status', table: 'report/report_status' },
    { column: 'report_id', name: 'Report ID', table: 'report' },
    { column: 'report_type', name: 'Report Type', table: 'report' },
    { column: 'action_type', name: 'Action Type', table: 'report' },
    { column: 'authorization_status', name: 'Authorization Status', table: 'report' },
    { column: 'submission_date', name: 'Submission Date', table: 'report' },
    { column: 'team_members', name: 'BAER Team Members', table: 'report_member,user' },
    { column: 'total_funding_req', name: 'Total Funding Requested', table: 'treatments' },
    { column: 'ro_auth', name: 'RO Authorized Funds', table: 'treatments' },
    { column: 'wo_auth', name: 'WO Authorized Funds', table: 'treatments' },
    { column: 'total_auth', name: 'Total Authorized Funds', table: 'treatments' },
    //treatment totals
    { column: 'treatment_all', name: 'Select All Treatments', table: 'treatments' },
    { column: 'treatment_unit', name: 'Unit', table: 'treatments' },
    { column: 'treatment_plants', name: 'Plants', table: 'treatments' },
    { column: 'treatment_ground_cover', name: 'Ground Cover', table: 'treatments' },
    { column: 'treatment_channel', name: 'Channel', table: 'treatments' },
    { column: 'treatment_heritage', name: 'Heritage', table: 'treatments' },
    { column: 'treatment_roads', name: 'Roads', table: 'treatments' },
    { column: 'treatment_safety', name: 'Safety', table: 'treatments' },
    { column: 'treatment_monitoring', name: 'Monitoring', table: 'treatments' },
    //soil burn severity acres
    { column: 'soil_burn_sev_developed', name: 'Developed', table: 'soil_burn_severity' },
    { column: 'soil_burn_sev_unburned', name: 'Unburned/Very Low', table: 'soil_burn_severity' },
    { column: 'soil_burn_sev_low', name: 'Low', table: 'soil_burn_severity' },
    { column: 'soil_burn_sev_moderate', name: 'Moderate', table: 'soil_burn_severity' },
    { column: 'soil_burn_sev_high', name: 'High', table: 'soil_burn_severity' },
    //user
    { column: 'name', name: 'Name', table: 'user' },
    { column: 'agency', name: 'Agency', table: 'user,location' },
    { column: 'skills_list', name: 'BAER Skills', table: 'user' },
    { column: 'skills_list_read', name: 'READ Skills', table: 'user_skills' },
    { column: 'skill_level', name: 'Skill Level', table: 'skills_list' },
    { column: 'fire_assignment', name: 'Fire Assignment Status', table: 'user_report' },
    { column: 'bear_role', name: 'Positions', table: 'user,baer_role' },
  ]

  constructor(
    public dialogRef: MatDialogRef<ReportsColumnsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.data.selectedColumns?.forEach((column: { column: string, name: string, table: string }) => {
      this.ColumnForm.get(column.column)?.setValue(true);
    })
  }

  setColumns() {
    let selectedColumns = this.columnList.filter((column: any) => this.ColumnForm.get(column.column)?.value)
    this.dialogRef.close(selectedColumns);
  }

  clearSelection() {
    this.ColumnForm.reset();
  }

  selectAllTreatments(event:any) {
    this.ColumnForm.controls['treatment_unit'].setValue(event.checked);
    this.ColumnForm.controls['treatment_plants'].setValue(event.checked);
    this.ColumnForm.controls['treatment_ground_cover'].setValue(event.checked);
    this.ColumnForm.controls['treatment_channel'].setValue(event.checked);
    this.ColumnForm.controls['treatment_heritage'].setValue(event.checked);
    this.ColumnForm.controls['treatment_roads'].setValue(event.checked);
    this.ColumnForm.controls['treatment_safety'].setValue(event.checked);
    this.ColumnForm.controls['treatment_monitoring'].setValue(event.checked);
  }
}
